import React, { useContext } from 'react';
import moment from 'moment';

import { YEAR_DASH_MONTH_DASH_DAY } from '../../../../../../constants/dateFormat';
import { PageInfoHeader } from '../../../../../PageInfoHeader/PageInfoHeader';
import { ReviewContext } from '../ReviewContext';

export default function ReviewInfoHeader() {
  const { reviewMetaData } = useContext(ReviewContext);

  const dateOfBirth = reviewMetaData?.dob ? getFormattedDOB(reviewMetaData.dob) : '---';
  const encounterName = reviewMetaData?.encounterName || '---';
  const studyName = reviewMetaData?.studyName;
  const siteName = reviewMetaData?.siteName;

  return (
    <PageInfoHeader
      objectRecordLabel={encounterName}
      pageInfo={
        <PageInfoHeader.CollapsibleList>
          <PageInfoHeader.AdditionalInfo title="Subject ID">
            {reviewMetaData?.subjectId || 'No Subject ID'}
          </PageInfoHeader.AdditionalInfo>
          <PageInfoHeader.AdditionalInfo tooltip="Date of Birth ">{dateOfBirth}</PageInfoHeader.AdditionalInfo>
          <PageInfoHeader.AdditionalInfo tooltip="Study">{studyName}</PageInfoHeader.AdditionalInfo>
          <PageInfoHeader.AdditionalInfo tooltip="Site">{siteName}</PageInfoHeader.AdditionalInfo>
        </PageInfoHeader.CollapsibleList>
      }
    />
  );
}

function getFormattedDOB(dob) {
  const age = moment().diff(moment(dob, YEAR_DASH_MONTH_DASH_DAY), 'years');
  return `${dob} (${age} ${age === 1 ? 'year' : 'years'})`;
}
